var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGamificationGrayStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 56,
    viewBox: "0 0 58 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.9901 34.91C61.6701 20.35 61.4601 19.7 42.6401 15.37C41.2601 15.05 40.1801 14.27 39.4501 13.05C29.5201 -3.51 28.8401 -3.51 18.9001 13.05C18.1701 14.27 17.1001 15.05 15.7101 15.37C-3.10985 19.7 -3.31986 20.35 9.36014 34.91C10.2901 35.98 10.7001 37.24 10.5801 38.66C8.88014 57.89 9.44015 58.29 27.2001 50.74C28.5101 50.18 29.8301 50.18 31.1401 50.74C48.9101 58.3 49.4601 57.9 47.7601 38.66C47.6301 37.25 48.0501 35.98 48.9801 34.91H48.9901Z",
    fill: "url(#paint0_radial_63_10)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_63_10",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 58,
    height: 56
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9901 34.91C61.6701 20.35 61.4601 19.7 42.6401 15.37C41.2601 15.05 40.1801 14.27 39.4501 13.05C29.5201 -3.51 28.8401 -3.51 18.9001 13.05C18.1701 14.27 17.1001 15.05 15.7101 15.37C-3.10985 19.7 -3.31986 20.35 9.36014 34.91C10.2901 35.98 10.7001 37.24 10.5801 38.66C8.88014 57.89 9.44015 58.29 27.2001 50.74C28.5101 50.18 29.8301 50.18 31.1401 50.74C48.9101 58.3 49.4601 57.9 47.7601 38.66C47.6301 37.25 48.0501 35.98 48.9801 34.91H48.9901Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_63_10)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.55
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0303 16.82C21.3503 17.26 21.0903 18.03 20.4103 18.5C19.7403 18.97 18.9103 18.96 18.6003 18.51C18.2803 18.06 18.6003 17.36 19.2603 16.89C19.9303 16.43 20.7103 16.38 21.0303 16.82Z",
    fill: "#699FCC"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7199 5.2C27.5799 7.32 23.9499 13.72 21.2599 15.1C20.0499 15.82 19.4699 15.41 19.9899 13.8C20.5999 11.9 24.2499 5.98 26.0399 4.14C27.1499 2.99 27.8299 3.58 27.7299 5.21L27.7199 5.2Z",
    fill: "url(#paint1_radial_63_10)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6302 38.8C45.7202 38.77 45.7802 39.09 45.7902 39.57C45.8002 40.05 45.7502 40.5 45.6602 40.55C45.5702 40.59 45.4602 40.21 45.4502 39.72C45.4502 39.23 45.5402 38.84 45.6302 38.81V38.8Z",
    fill: "#61739E"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7201 38.97C12.6301 38.94 12.5701 39.25 12.5601 39.71C12.5601 40.17 12.6001 40.61 12.6901 40.65C12.7801 40.69 12.8901 40.32 12.9001 39.85C12.9001 39.38 12.8101 39 12.7201 38.97Z",
    fill: "#61739E"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1799 17.38C42.1799 17.28 42.4999 17.33 42.9399 17.47C43.3799 17.61 43.7899 17.8 43.7999 17.9C43.8099 18 43.4199 17.98 42.9599 17.84C42.5099 17.7 42.1699 17.48 42.1699 17.38H42.1799Z",
    fill: "#6E7FA6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_63_10",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.3501 13.88) scale(56.89 56.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DD9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#76AADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#4570AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#335A9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#365FA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#416FB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#548AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#6EB1E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3371B5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_63_10",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.7999 22.21) scale(24.44)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.67
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1B1C1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3C3E41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#6A6D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#A4A8B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5DAE5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamificationGrayStar);
export default __webpack_public_path__ + "static/media/gamification-gray-star.95f25fe5a7a167f7434cba8b11b16f9f.svg";
export { ForwardRef as ReactComponent };